module.exports = __webpack_public_path__ + "static/media/Note-Click-Enter-Textures-Click_in_00018.e6bacd23.png";